import { render, staticRenderFns } from "./itinerary_air_base.vue?vue&type=template&id=052e5c02&"
import script from "./itinerary_air_base.vue?vue&type=script&lang=js&"
export * from "./itinerary_air_base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports